export default __webpack_public_path__ + "static/media/eHealth_release.57f88aee.jpg";